import api from './api';
import { buildMerchantDocumentRequest } from '../utils/gatewayDocuments';

const getMerchantList = async (path, params, { signal } = {}) => {
    try {
        const response = await api.get(path, { params, signal });
        return response.data;
    } catch (error) {
        return error.response?.data || { success: false, message: error.message };
    }
};

const merchantService = {
    exportProviders: async id => (await api.get(`/merchant/${id}/providers/export`, { responseType: 'blob' })).data,

    importProviders: async (id, { file, mode = 'dry-run', skipIssues = false, resolutions = {}, confirmationToken }) => {
        const data = new FormData();
        data.append('file', file);
        data.append('mode', mode);
        data.append('skip_issues', String(skipIssues));
        data.append('resolutions', JSON.stringify(resolutions));
        if (confirmationToken) data.append('confirmation_token', confirmationToken);
        return (await api.post(`/merchant/${id}/providers/import`, data, {
            headers: { 'Content-Type': 'multipart/form-data' }, timeout: 300000
        })).data;
    },
    /**
     * Get all merchants with pagination and search
     */
    getMerchants: (params, options) => getMerchantList('/merchant', params, options),

    searchMerchants: (params, options) => getMerchantList('/merchant/search', params, options),

    /**
     * Get a single merchant by ID
     */
    getMerchantById: async (id) => {
        try {
            const response = await api.get(`/merchant/${id}`);
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    },

    /**
     * Create a new merchant
     */
    createMerchant: async (data) => {
        try {
            const request = buildMerchantDocumentRequest(data);
            const response = await api.post('/merchant', request, request instanceof FormData ? {
                headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000
            } : undefined);
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    },

    /**
     * Update a merchant
     */
    updateMerchant: async (id, data) => {
        try {
            const request = buildMerchantDocumentRequest(data);
            const response = await api.put(`/merchant/${id}`, request, request instanceof FormData ? {
                headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120000
            } : undefined);
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    },

    /**
     * Delete a merchant
     */
    deleteMerchant: async (id) => {
        try {
            const response = await api.delete(`/merchant/${id}`);
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    },

    /**
     * Get paginated and filtered providers for a specific merchant
     */
    getMerchantProviders: async (id, params) => {
        try {
            const response = await api.get(`/merchant/${id}/providers`, { params });
            return response.data;
        } catch (error) {
            return error.response?.data || { success: false, message: error.message };
        }
    }
};

export default merchantService;
